import type { ReactNode } from 'react'

import { Flex, Text } from '@enechain/ecloud-designsystem'

type PageSectionProps = {
  /** セクション見出し。textStyle="sectionTitle" 固定。 */
  title: string
  /** 見出し右端の操作。 */
  actions?: ReactNode
  children: ReactNode
}

/**
 * セクション見出し + 本文 (frontend-design-unification 設計書 §5.1)。
 * 見出し行レイアウト (title 左 / actions 右)・見出し-本文間 gap は内部固定 (prop 化しない)。
 * 折りたたみセクションは対象外 (ecloud AccordionRoot の領分)。
 */
export const PageSection = ({
  title,
  actions,
  children,
}: PageSectionProps): React.ReactElement => (
  <Flex flexDirection="column" gap={3}>
    <Flex alignItems="center" justifyContent="space-between">
      <Text textStyle="sectionTitle">{title}</Text>
      {actions}
    </Flex>
    {children}
  </Flex>
)
